import BasicView from '@/views/BasicView.vue'
import Enter from '@/views/Enter.vue'
import {getUserState} from "@/services/HttpSvc";

/**
 * Maps the data from the API to the key names used by vue-router
 * @param  {Array} routerData The tabs data from the API
 * @return {Array}            A list of vue-router ready route objects
 */
export default function mapVueRoutes(routerData) {
  return routerData.map(({ title, slug, body }) =>
      slug === 'enter' ?
        enterRoute :
      slug === 'categories' ?
        createRoute(title, `/${slug}`,
          () => import(/* webpackChunkName: "categories" */ '@/views/Categories.vue'),
          { body }) :
      slug === 'winners' ?
        createRoute(title, `/${slug}`,
          () => import(/* webpackChunkName: "winners" */ '@/views/Winners.vue'),
          { body }) :
      slug === 'supporters' ?
        createRoute(title, `/${slug}`,
          () => import(/* webpackChunkName: "categories" */ '@/views/Supporters.vue'),
          { body }) :
      slug === 'judges' ?
        createRoute(title, `/${slug}`,
          () => import(/* webpackChunkName: "judges" */ '@/views/Judges.vue')) :
      slug === 'sponsors' ?
        createRoute(title, `/${slug}`,
          () => import(/* webpackChunkName: "judges" */ '@/views/Sponsors.vue'),
          { body }) :
        createRoute(title, `/${slug}`, BasicView, { body }))
}

const enterRoute = {
  path: '/enter',
  name: 'Enter',
  component: Enter,
  children: [
    {
      path: '/',
      name: 'Register',
      component: () =>
          import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
      meta: {
        authRedirect: '/enter/nominate',
      },
    },
    {
      path: '/enter/nominate',
      name: 'Nominate',
      component: () =>
          import(/* webpackChunkName: "nominate" */ '@/views/Nominate.vue'),
      meta: {
        requiresAuth: '/enter/register',
      },
    },
  ],
  beforeEnter: async (to, from, next) => {
    const userState = await getUserState()
    //console.log(userState)
    if (userState.has_previous_nominations && userState.nominations_open) {
      window.location = "/user/purple-ribbon/nominations"
    } else {
      next()
    }
  },
}

function createRoute(name, path, component, props) {
  return {
    name,
    path,
    component,
    props,
  }
}
